import axios from 'axios';

// Read a cookie value by name (used to retrieve the XSRF-TOKEN set by Spring Security)
function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[2]) : null;
}

// Module-level promise to avoid multiple concurrent prefetch requests.
// Shared across all axios instances created by the factory.
let csrfPrefetchPromise = null;

/**
 * If the XSRF-TOKEN cookie is missing, makes a lightweight GET to a
 * public endpoint so the server sets the cookie via CsrfCookieFilter.
 * Returns a promise that resolves once the cookie is available.
 */
function ensureCsrfCookie() {
    if (getCookie('XSRF-TOKEN')) {
        return Promise.resolve();
    }
    if (!csrfPrefetchPromise) {
        csrfPrefetchPromise = axios
            .get('/eca/health', { withCredentials: true })
            .catch(function () { /* best-effort */ })
            .then(function () { csrfPrefetchPromise = null; });
    }
    return csrfPrefetchPromise;
}

export default (baseURL, headers = {}, history = null) => {
    const timeout = 10000000;

    const axiosInstance = axios.create({
        baseURL: baseURL,
        timeout,
        headers: { ...headers },
        xsrfCookieName: 'XSRF-TOKEN',
        xsrfHeaderName: 'X-XSRF-TOKEN',
        withCredentials: true,
    });

    // For state-changing requests (POST, PUT, DELETE, PATCH):
    // 1. If the XSRF-TOKEN cookie is missing, prefetch it via a GET.
    // 2. Read the cookie at request time and attach the header.
    axiosInstance.interceptors.request.use(function (config) {
        var method = (config.method || '').toLowerCase();
        if (method === 'get' || method === 'head' || method === 'options') {
            return config;
        }
        return ensureCsrfCookie().then(function () {
            var csrfToken = getCookie('XSRF-TOKEN');
            if (csrfToken) {
                config.headers['X-XSRF-TOKEN'] = csrfToken;
            }
            return config;
        });
    });

    axiosInstance.interceptors.response.use(
        (response) => // this code is handling for Success 200.
            new Promise((resolve, reject) => {
                resolve(response);
            }),
        (error) => { // this code is handling for other status 500,404.
            
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }
    );

    return axiosInstance;
};
